export default __webpack_public_path__ + "static/media/99.e913162a.jpg";